import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Home = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27.7 14.475C27.5 13.987 27.2 13.55 26.837 13.175L18.837 5.175C18.087 4.425 17.062 4 16.012 4C14.962 4 13.924 4.425 13.187 5.175L5.18699 13.175C4.81199 13.55 4.52499 13.988 4.32499 14.475C4.12499 14.962 4.02499 15.475 4.02499 16V25C4.02499 26.65 5.37499 28 7.02499 28H25.025C26.675 28 28.025 26.65 28.025 25V16C28 15.475 27.9 14.963 27.7 14.475V14.475ZM14 26V22C14 20.9 14.9 20 16 20C17.1 20 18 20.9 18 22V26H14ZM26 25C26 25.55 25.55 26 25 26H20V22C20 19.8 18.2 18 16 18C13.8 18 12 19.8 12 22V26H6.99999C6.44999 26 5.99999 25.55 5.99999 25V16C5.99999 15.738 6.04999 15.475 6.14999 15.238C6.24999 14.988 6.39999 14.775 6.58799 14.588L14.588 6.588C14.963 6.213 15.475 6 16 6C16.525 6 17.038 6.213 17.413 6.588L25.413 14.588C25.601 14.776 25.75 14.988 25.851 15.238C25.952 15.488 26.001 15.738 26.001 16V25H26Z" />
	</svg>
);

export default Home;
